import { useEffect, useState } from "react";
import { keyBy } from 'lodash';
import useAllRoutes from "./useAllRoutes";
const useAllServices = () => {
    const {allRoutesArray} = useAllRoutes();
    const [allServicesArray, setAllServicesArray] = useState([]);
    const [allServices, setAllServices] = useState();
    useEffect(() => {
      if (allRoutesArray) {
        const services = allRoutesArray.map(route => route.services).flat();
        setAllServices(keyBy(services, 'tripId'));
        setAllServicesArray(services);
      }
    }, [allRoutesArray]);
    return { allServices, allServicesArray };
  };

export default useAllServices;